// extracted by mini-css-extract-plugin
export default {"loadPostMainLayout":"style_loadPostMainLayout__38UxD","body":"style_body__WCbHX"};